export const Link = {
    baseStyle() {
        return {
            textDecoration: 'none',
            _hover: {
                textDecoration: 'none',
            },
        };
    },
    variants: {},
    sizes: {},
    defaultProps: {},
};
